import "../../assets/css/common.css";
import "../../assets/css/font.css";

import {Route, Routes, useLocation} from "react-router-dom";
import React, {lazy, Suspense, useEffect} from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";

const Home = lazy(() => import('../home').then((module) => ({default: module.Home})));

const Lucky = lazy(() => import('../lucky').then((module) => ({default: module.Lucky})));
const LuckyPrivacy = lazy(() => import('../lucky/privacy').then((module) => ({default: module.LuckyPrivacy})));
const LuckyDraw = lazy(() => import('../lucky/draw').then((module) => ({default: module.LuckyDraw})));
const LuckyResult = lazy(() => import('../lucky/result').then((module) => ({default: module.LuckyResult})));
const LuckyReceive = lazy(() => import('../lucky/receive').then((module) => ({default: module.LuckyReceive})));

export const App = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <TransitionGroup>
            <CSSTransition key={location.pathname} classNames="fade" timeout={500}>
                <Suspense>
                    <Routes location={location}>
                        <Route path="/" element={<Home/>}/>

                        <Route path="/lucky" element={<Lucky/>}/>
                        <Route path="/lucky/privacy" element={<LuckyPrivacy/>}/>
                        <Route path="/lucky/draw" element={<LuckyDraw/>}/>
                        <Route path="/lucky/result" element={<LuckyResult/>}/>
                        <Route path="/lucky/receive" element={<LuckyReceive/>}/>
                    </Routes>
                </Suspense>
            </CSSTransition>
        </TransitionGroup>
    );
}
